import styled from "styled-components";
import { type CloseProps } from "./close";
import { getBackgroundColor, getColor, getScaleOnHover, getSize, getSpanBackgroundColor } from "./close.styles.utils";
import { createShouldForwardPropBlockList, deepMerge } from "../utils/helper";

type WrapperProps = Pick<CloseProps, "color" | "size" | "background">;

export const Wrapper = styled("button").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["size", "color", "background"]),
})<WrapperProps>(({ size, color, background, theme }) => ({
    borderRadius: theme.borderRadius.full,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    rotate: "45deg",
    ...deepMerge(getSize(size, theme), getBackgroundColor(color, background, theme), getColor(color, background, theme)),
    "& > span": {
        "&:before, &:after": {
            content: '""',
            position: "absolute",
            width: theme.spacing[1.5],
            height: theme.spacing[0.5],
            left: "50%",
            top: "50%",
            translate: "-50% -50%",
            borderRadius: theme.borderRadius.full,
            transition: "all 200ms",
            ...deepMerge(getSpanBackgroundColor(color, background, theme)),
        },
        "&:before": {
            marginLeft: "-3px",
            transformOrigin: "center right",
        },
        "&:after": {
            marginLeft: "3px",
            transformOrigin: "center left",
        },
        "& > span": {
            "&:before, &:after": {
                content: '""',
                position: "absolute",
                width: theme.spacing[0.5],
                height: theme.spacing[1.5],
                left: "50%",
                top: "50%",
                translate: "-50% -50%",
                borderRadius: theme.borderRadius.full,
                transition: "all 0.2s",
                ...deepMerge(getSpanBackgroundColor(color, background, theme)),
            },
            "&:before": {
                marginTop: "-3px",
                transformOrigin: "center bottom",
            },
            "&:after": {
                marginTop: "3px",
                transformOrigin: "center top",
            },
        },
    },
    "&:hover": {
        "& > span": {
            "&:before": {
                marginLeft: size !== "sm" ? "-5px" : undefined,
                ...deepMerge(getScaleOnHover(size)),
            },
            "&:after": {
                marginLeft: size !== "sm" ? "5px" : undefined,
                ...deepMerge(getScaleOnHover(size)),
            },
            "& > span": {
                "&:before": {
                    marginTop: size !== "sm" ? "-5px" : undefined,
                    ...deepMerge(getScaleOnHover(size)),
                },
                "&:after": {
                    marginTop: size !== "sm" ? "5px" : undefined,
                    ...deepMerge(getScaleOnHover(size)),
                },
            },
        },
    },
}));
